import { apiClient } from "../lib/api";

export const medicalApi = {
  listChecks: (status) => apiClient.get("/medical-checks", { params: { status: status || undefined } }),
  getCheck: (employeeId) => apiClient.get(`/medical-checks/${employeeId}`),
  setFrequency: (employeeId, payload) => apiClient.post(`/medical-checks/${employeeId}/frequency`, payload),
  acknowledgeCompleted: (employeeId, payload) => apiClient.post(`/medical-checks/${employeeId}/acknowledge-completed`, payload),

  myStatus: () => apiClient.get("/medical-checks/my/status"),
  scheduleMyAppointment: (scheduledDate) => apiClient.post("/medical-checks/my/schedule-appointment", { scheduled_date: scheduledDate }),
};
